// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"286":"39dee058","982":"c3b98ca1"}[chunkId] + ".chunk.css";
};